<template>
  <div>
    <div v-for="(resultado, index) in resultados"
         :key="`gerenciador_resultados_item_${ _uid }_${ index }`"
         class="row GerenciadorResultadosItem no-gutters mb-2">
      <div class="col">
        <div class="row">
          <div class="col">
            <div class="GerenciadorResultadosItem--header pb-2 pt-1"
                 :class="getClass(resultado)">
              <div class="row">
                <div class="col">
                  <h6 class="">
                    <!-- 
                      <span v-if="resultado.status != 'CUMPRIDA' && resultado.status != 'CUMPRIDA_MANUAL'"
                          style="float: left;"
                          class="mr-1">
                      <icon-svg icon="alert"
                                :class="{ 'mt-1': resultado.status != 'CUMPRIDA' & resultado.status != 'CUMPRIDA_MANUAL' }"
                                class="icon icon--sm icons--white mt-3" />
                      </span>
                    -->
                    <span style="float: left;"
                          class="mt-2 pt-1">
                      <b-form-checkbox
                        v-if="resultado.status != 'CUMPRIDA' & resultado.status != 'CUMPRIDA_MANUAL'"
                        :id="`selecionar_todos_registros_${ _uid }_${ index }`"
                        v-model="selecionados"
                        :name="`selecionar_todos_registros_${ _uid }_${ index }`"
                        :value="resultado.registro_id" />
                    </span>
                    <label v-if="['D', 'C', 'CR'].indexOf(resultado.registro.tipo_registro) === -1"
                           :for="`selecionar_todos_registros_${ _uid }_${ index }`"
                           class="m-0 mt-1 ml-1 pt-1">
                      {{ resultado.registro && resultado.registro.pessoas[0].nome }}
                      <div class="mt-1">
                        <small>matrícula: </small>{{ resultado.registro.matricula | maskMatricula }}
                      </div>
                    </label>
                    <label v-else
                           :for="`selecionar_todos_registros_${ _uid }_${ index }`"
                           class="m-0 mt-1 ml-1 pt-1">
                      {{ resultado.registro.pessoas[0].nome_antigo || resultado.registro.pessoas[0].nome }}
                      e
                      {{ resultado.registro.pessoas[1].nome_antigo || resultado.registro.pessoas[1].nome }}
                      <div class="mt-1">
                        <small>matrícula: </small>{{ resultado.registro.matricula | maskMatricula }}
                      </div>
                    </label>
                  </h6>
                </div>
                <div v-if="resultado.status != 'CUMPRIDA' && resultado.status !== 'CUMPRIDA_MANUAL'"
                     class="col-4 text-right">
                  <button class="btn btn-outline-light mt-2 px-4"
                          @click="showPendencias(`BoxPendencia${index}`)">
                    Pendências {{ resultado.errors ? `(${getQtdErrors(resultado.errors)})` : '' }}
                  </button>
                </div>
                <div v-if="resultado.status === 'CUMPRIDA_MANUAL'"
                     class="mt-3 mr-3">
                  <b class="mr-2"> Envio Manual</b>
                  <IconSvg icon="touch"
                           class="icon--sm icon-cumprida-manual" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row GerenciadorResultadosItem--content">
          <div class="col">
            <div class="row">
              <div class="col">
                <table style="width: 100%;">
                  <tr>
                    <th>
                      Serviço
                    </th>
                    <th>
                      Data
                    </th>
                    <th>
                      Data máxima para cumprir
                    </th>
                    <th>
                      Data cumprimento
                    </th>
                    <th>
                      Data Registro
                    </th>
                    <!--<th>
                      Data Ato
                    </th>-->
                    <th>
                      Tipo de registro
                    </th>
                    <!--<th>
                      OS
                    </th>-->
                  </tr>
                  <tr>
                    <td>
                      {{ getTipo(resultado) }}
                    </td>
                    <td>
                      {{ resultado.data_inclusao | date }}
                    </td>
                    <td>
                      {{ resultado.data_max_cumprimento | date }}
                    </td>
                    <td v-if="resultado.data_cumprimento">
                      {{ resultado.data_cumprimento | date }}
                    </td>
                    <td v-else>
                      Não cumprida
                    </td>
                    <td>
                      {{ resultado.registro.data_registro | date }}
                    </td>
                    <!--<td>
                      00/00/0000
                    </td>-->
                    <td>
                      {{ tiposRegistro[resultado.registro.tipo_registro] }}
                    </td>
                    <!--<td>
                      0000
                    </td>-->
                  </tr>
                </table>
              </div>
            </div>
            <BoxPendencias :ref="`BoxPendencia${index}`"
                           :prop-errors="resultado.errors"
                           :prop-tarefa-id="resultado.tarefa_id"
                           :prop-show-os="!resultado.registro.ordemServico.length"
                           :prop-tarefa="resultado"
                           @goToRegisterOS="goToRegisterOS(resultado)"
                           @reload="$emit('onCumprirTodos')"
                           @openRegister="openRegister(resultado)" />
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <gerenciador-resultados-action @onCumprirTodos="carga()" />
      </div>
    </div>

    <div>
      <b-modal v-if="erroCarga.status"
               id="modalMotivoAlteracao"
               ref="modalMotivoAlteracao"
               centered
               size="lg"
               :visible="true"
               title="Status da carga:"
               @hide="erroCarga.status = false">
        {{ erroCarga.text }}
        <hr>
        <h6 class="mb-1">
          Cargas com erro:
        </h6>

        <collapse-default v-for="(task, index) in erroCarga.tasks"
                          :id="`${ _uid }_task_${ index }`"
                          :key="`${ _uid }_task_${ index }`"
                          icon-position="left"
                          :collapse-visible="index == 0"
                          class="GerenciadorResultadosItem">
          <template v-slot:header>
            <span v-if="['D', 'C', 'CR'].indexOf(task.registro.tipo_registro) === -1">
              {{ task.registro.pessoas[0].nome }}
            </span>
            <span v-else>
              {{ task.registro.pessoas[0].nome_antigo || task.registro.pessoas[0].nome }}
              e
              {{ task.registro.pessoas[1].nome_antigo || task.registro.pessoas[1].nome }}
            </span>
            <button class="mr-1 btn btn-danger btn-sm float-right GerenciadorResultadosItem--btnAjustar"
                    @click="openRegister(task)">
              Ajustar
            </button>
          </template>

          <template v-slot:content>
            <div class="p-2">
              <label class="label">
                Erros do registro:
              </label>
              <ul v-if="Array.isArray(task.message)">
                <li v-for="(error, indexes) in task.message"
                    :key="`${ _uid }_erro_task_${ indexes }`">
                  {{ error }}
                </li>
              </ul>
              <ul v-else>
                <li v-if="!!task.message">
                  {{ task.message }}
                </li>
                <li v-if="typeof task.message == 'string'">
                  {{ task.message }}
                </li>
              </ul>
            </div>
          </template>
        </collapse-default>
      </b-modal>
    </div>
    <Carga ref="Carga"
           :prop-registros="selecionados"
           :prop-lote="true"
           :prop-resultados="propResultados"
           @showErrors="getErrorsCarga"
           @reload="$emit('onCumprirTodos')" />
  </div>
</template>

<script>
  /* components */
  import GerenciadorResultadosAction from "@/components/SofiaRei/Gerenciador/GerenciadorResultados/GerenciadorResultadosAction"
  import CollapseDefault from "@/components/SofiaRei/Resumo/Collapses/CollapseDefault"
  import Carga from '@/components/SofiaRei/Carga/Carga'
  import BoxPendencias from '../BoxPendencias'

  /* constants */
  import { tipos, acoes } from "@/constants/gerenciador"
  import errosCarga from '@/constants/errosCarga'
  import { GERENCIADOR_TAREFAS_ENVIAR, ADMIN } from "@/constants/permissions"

  /* outros */
  import {mapGetters} from "vuex"

  export default {
    name: "GerenciadorResultadosItem",
    components: {
      GerenciadorResultadosAction,
      CollapseDefault,
      Carga,
      BoxPendencias
    },
    props: {
      propResultados: {
        type: Array,
        default: () => ({})
      },
      propSelecionarTodos: {
        type: Boolean,
        default: () => false
      }
    },
    data () {
      return {
        erroCarga: {
          status: false,
          text: null,
          tasks: []
        },
        tipos,
        acoes,
        selecionados: [],
        resultados: [],
        tiposRegistro: {
          N: 'Nascimento',
          O: 'Óbito',
          D: 'Casamento',
          C: 'Casamento',
          CR: 'Casamento Religioso'
        },
        GERENCIADOR_TAREFAS_ENVIAR,
        ADMIN
      }
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser'
      })
    },
    watch: {
      propSelecionarTodos () {
        if (this.propSelecionarTodos) {
          this.selecionados = this.propResultados
            .filter(selecionado => selecionado.status != 'CUMPRIDA')
            .map(selecionado => selecionado.registro_id)
        } else {
          this.selecionados = []
        }
      },
      propResultados () {
        this.init()
      }
    },
    created () {
      this.init()
    },
    methods: {
      changeShowErrors (collapseId) {
        this.$root.$emit('bv::toggle::collapse', collapseId)
      },
      init () {
        this.resultados = this.propResultados.map(resultado => {
          if (resultado.errors) {
            resultado.errors = JSON.parse(resultado.errors)
          }
          return resultado
        })

        this.selecionados = this.selecionados.filter(selecionado =>
          this.resultados.find(resultado => resultado.registro_id === selecionado)
        )
      },
      goToRegisterOS (resultado) {
        if (!!resultado.registro.obito) {
          this.$router.push({ name: 'resumo_obito', params: { id: resultado.registro.obito.obito_id, propNovo: true } })
        } else if (!!resultado.registro.nascimento) {
          this.$router.push({ name: 'resumo_nascimento', params: { id: resultado.registro.nascimento.nascimento_id, propNovo: true } })
        } else if (!!resultado.registro.casamento) {
          this.$router.push({ name: 'resumo_casamento', params: { id: resultado.registro.casamento.casamento_id, gerarOS: true } })
        }
      },
      openRegister (task) {
        const sla = (listErrors) => {
          const correcoes = {}
          let keys = []

          if (!Array.isArray(listErrors)) {
            if (!!listErrors) {
              listErrors = [listErrors]
            }
          }

          let errosTipoRegistro = null

          if (task.obito_id || task.registro && task.registro.obito && task.registro.obito.obito_id) {
            errosTipoRegistro = errosCarga.obito
            keys = Object.keys(errosCarga.obito)
          } else if (task.nascimento_id || task.registro && task.registro.nascimento && task.registro.nascimento.nascimento_id) {
            errosTipoRegistro = errosCarga.nascimento
            keys = Object.keys(errosCarga.nascimento)
          } else {
            errosTipoRegistro = errosCarga.casamento
            keys = Object.keys(errosCarga.casamento)
          }

          keys.forEach((key) => {
            listErrors.forEach(err => {
              err = err.toUpperCase()

              if (err.match("\\b" + key + "\\b")) {
                correcoes[key] = errosTipoRegistro[key]
              }
            })
          })
          return correcoes
        }

        let erros = {}

        if (task.message) {
          erros = sla(task.message)
        } else {
          erros = sla(task.errors)
        }

        if (!!task.obito_id || task.registro && task.registro.obito && task.registro.obito.obito_id) {
          const obito_id = task.obito_id || task.registro.obito.obito_id

          this.$router.push({name: 'editar_obito', params: { id: obito_id, propCorrecoes: erros }})
        } else if (!!task.nascimento_id || task.registro && task.registro.nascimento && task.registro.nascimento.nascimento_id) {
          const nascimento_id = task.nascimento_id || task.registro.nascimento.nascimento_id

          this.$router.push({name: 'edicao_nascimento', params: { idNasc: nascimento_id, propCorrecoes: erros }})
        } else if (!!task.casamento_id || task.registro && task.registro.casamento && task.registro.casamento.casamento_id) {
          const casamento_id = task.casamento_id || task.registro.casamento.casamento_id

          this.$router.push({name: 'editar_casamento', params: { id: casamento_id, propCorrecoes: erros }})
        }
      },
      getTipo (item) {
        const acao = this.acoes.find(acao => acao.belongs.indexOf(item.tipo) != -1 && acao.value == item.acao)
        return acao && acao.label || 'Tipo indefinido'
      },
      getClass (resultado) {
        switch (resultado.status) {
        case 'CUMPRIDA':
        case 'CUMPRIDA_MANUAL':
          return { 'GerenciadorResultadosItem--green': true }
          break

        case 'A_VENCER':
          return { 'GerenciadorResultadosItem--yellow': true }
          break

        case 'VENCIDA':
          return { 'GerenciadorResultadosItem--red': true }
          break
        }
      },
      carga () {
        /**
         * Verificamos a permissão no método pois a carga também é chamada
         * fora do gerenciador de tarefas
         *
         * Se o usuario for suporte ou oficial não verificamos
         */
        const { groups, flag_oficial } = this.user

        let login = ''

        if (this.user) {
          login = this.user.login.split('_')[0]
        }

        if (groups && groups.length && !flag_oficial) {
          let access = false
          const permissions = [this.GERENCIADOR_TAREFAS_ENVIAR, this.ADMIN]

          groups.forEach(group => {
            const permission = !!group.permissions.find(permission => !!permissions.includes(permission.codename))

            if (permission && group.ativo) access = true
          })

          if (!access) {
            return displayMessage('error', 'Acesso negado!', 'Você não tem permissão para acessar essa função.')
          }
        } else if (login !== 'suporte' && !flag_oficial) {
          return displayMessage('error', 'Acesso negado!', 'Você não tem permissão para acessar essa função.')
        }

        // Usamos a ref pra chamar uma função dentro de outro componente
        this.$refs.Carga.handleCarga()
      },
      getErrorsCarga (error) {
        // pega o dado do resultado da busca
        // e junta com o erro da carga para mostrar
        // os dados na listagem de erro
        this.erroCarga = error

        error.tasks.map(task => {
          const resultado = this.propResultados.find(resultado => resultado.registro_id == task.registro_id)
          Object.assign(task, resultado)
        })

        this.erroCarga = error
      },

      showPendencias (name) {
        this.$refs[name][0].showBox()
      },
      getQtdErrors (errors) {
        if (Array.isArray(errors)) {
          return errors.length
        } else {
          return '1'
        }
      }
    }
  }
</script>

<style lang="scss">
  @import "../../../../scss/_utilities/_exports";

  .GerenciadorResultadosItem {
    box-shadow: 2px 2px 4px #00000029;

    &--btnAjustar{
      margin-top: -3px
    }

    &--header {
      background-color: #C6C6C6;
      padding: 13px;
    }

    &--content {
      padding: 5px;
      font-size: 14px;
    }

    &--red {
      background-color: #8b0000;
      color: #ffffff;
    }

    &--green {
      background-color: #01bfa5;
      color: #ffffff;
    }

    &--yellow {
      background-color: #7f7e14;
      color: #ffffff;
    }
  }

  .icon-cumprida-manual {
    fill: #FFFFFF;
  }
</style>
